import Pagination from 'react-bootstrap/Pagination';

function PaginationComponent(props) {

    const handleBackClick = () => {
        props.handleBackClick();
    };

    const handleNextClick = () => {
        props.handleNextClick();
    };

    return (
        <div className='pagination_screen'>
            <Pagination>
                <Pagination.Prev className='pagination_buttons' onClick={() => handleBackClick()} />
                {
                    props && props.totalPages ?
                        props.totalPages.map((item, i) => {
                            return (
                                <Pagination.Item
                                    active={parseInt(props.page) === parseInt(i + 1) ? true : false}
                                    onClick={() => props.setPage(i + 1)}
                                    key={i}
                                >
                                    {i + 1}
                                </Pagination.Item>
                            )
                        })
                        :
                        <Pagination.Item active >
                            1
                        </Pagination.Item>
                }
                <Pagination.Next className='pagination_buttons' onClick={() => handleNextClick()} />
            </Pagination>
        </div>
    );
}

export default PaginationComponent;